import { formatFechaAnioMesDia } from "../../../../../utils/fechaUtils";
import { diasEnFinca, diasOcupacion } from "../../../../../utils/ganaderiaUtils";
import { _miles } from "../../../../../utils/numberUtils";
import { LoteInfoRender, LoteInfoRow } from "./LoteInfoRender";

/** Ficha de lote para fincas de ganadería: animales, días de ocupación/en finca,
 *  último ingreso y peso estimado. */
export class LoteInfoGanaderiaRender extends LoteInfoRender {
  protected getExtraRows(): LoteInfoRow[] {
    const lote = this._lote;
    const ocupacion = diasOcupacion(lote);
    const enFinca = diasEnFinca(lote);
    const pesoEstimado = lote.ganaderiaPesoEstimadoTotalKg;

    return [
      { label: "Animales", value: _miles(lote.ganaderiaCantidadAnimales) },
      {
        label: "Días de ocupación",
        value: ocupacion != null ? `${ocupacion} días` : "—",
      },
      {
        label: "Días en finca",
        value: enFinca != null ? `${enFinca} días` : "—",
      },
      {
        label: "Último ingreso",
        value: lote.ganaderiaUltimoIngreso
          ? formatFechaAnioMesDia(lote.ganaderiaUltimoIngreso)
          : "—",
      },
      {
        label: "Peso estimado",
        value:
          pesoEstimado != null && pesoEstimado > 0
            ? `${_miles(pesoEstimado)} kg`
            : "—",
      },
    ];
  }
}
